export class Symbols {
    static triangleUp = 'triangle-up';
    static triangleDown = 'triangle-down';
    static circle = 'circle';
}